import { createFileRoute } from "@tanstack/react-router"

import { TermsOfUseRouteComponent } from "@/routes/terms-of-use"

export const Route = createFileRoute("/qr/$qrLookupID/terms-of-use")({
  staticData: {
    pageName: "Terms of Use",
  },
  component: TermsOfUseRouteComponent,
})
